<!-- eslint-disable -->
<template lang="pug">
    game-preview-settings
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_game') }}
            span(slot="value")
                template(v-if="parameters.game === 'InteractiveFlashCards'")
                    | {{ $i18n.t('common.common_gameName_interactiveFlashCards') }}
                template(v-else-if="parameters.game === 'FlashCards'")
                    | {{ $i18n.t('common.common_gameName_flashCards') }}
        game-preview-setting(v-if="parameters.duration")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_duration') }}
            span(slot="value")
                | {{ parameters.duration }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_minutes') }}
        template(v-if="parameters.isSeries")
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numOfSeries') }}
                span(slot="value") {{ parameters.seriesAmount }}
            game-preview-setting
                span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numsInSeries') }}
                span(slot="value") {{ parameters.seriesExamples }}
        game-preview-setting(v-else-if="parameters.amount")
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_numbersCount') }}
            span(slot="value") {{ parameters.amount }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_speed') }}
            span(slot="value") {{ parameters.speed }} {{ $i18n.t('trainer.trainer_gameFormSettingValue_seconds') }}
        game-preview-setting
            span(slot="name") {{ $i18n.t('trainer.trainer_gameFormSetting_difficulty') }}
            span(slot="value") {{ difficultyStringified(parameters.difficult) }}
</template>

<script>
    /*eslint-disable*/
    import FlashCardsPreviewMixin from "../../../utils/trainer/FlashCardsPreviewMixin"
    import GamePreviewSettings from './GamePreviewSettings.vue'
    import GamePreviewSetting from './GamePreviewSetting.vue'

    export default {
        props: ['parameters', 'exerciseId', 'type'],
        mixins: [FlashCardsPreviewMixin],
        components: {
            GamePreviewSettings,
            GamePreviewSetting
        }
    }
</script>